import React from 'react';
import { Button } from './Button';
import { FadeIn } from './FadeIn';
import { ShieldCheck, Download, Zap } from 'lucide-react';
export function ValueStack() {
  return <section id="pricing" className="bg-brand-green py-24 px-6 text-white relative overflow-hidden" data-id="element-498">
      {/* Decorative background */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-10 pointer-events-none" data-id="element-499">
        <div className="absolute -top-24 -right-24 w-96 h-96 bg-brand-gold rounded-full blur-3xl" data-id="element-500"></div>
        <div className="absolute -bottom-24 -left-24 w-96 h-96 bg-brand-beige rounded-full blur-3xl" data-id="element-501"></div>
      </div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-502">
        <FadeIn data-id="element-503">
          {/* Total value */}
          <div className="text-center mb-12" data-id="element-504">
            <p className="text-white/50 uppercase tracking-widest text-sm font-bold mb-3" data-id="element-505">
              VALOR TOTAL DEL SISTEMA
            </p>
            <p className="text-3xl md:text-5xl font-serif font-bold text-brand-gold line-through decoration-white/30" data-id="element-506">
              Más de $147 en valor real
            </p>
          </div>

          {/* Product pack image — protagonist */}
          <div className="mb-14 px-2" data-id="element-507">
            <img src="https://cdn.magicpatterns.com/uploads/pMj2pQ9eMsTf39c2oSvjyZ/ChatGPT_Image_15_abr_2026,_06_29_58.png" alt="Sistema completo: Ebook principal + 3 bonos incluidos" className="w-full max-w-3xl mx-auto h-auto rounded-2xl object-contain" data-id="element-508" />
          </div>

          {/* Price card */}
          <div className="bg-white text-brand-green rounded-2xl p-8 md:p-10 shadow-2xl max-w-2xl mx-auto" data-id="element-509">
            <p className="text-lg md:text-xl font-bold text-brand-text/70 mb-4 text-center" data-id="element-510">
              🔥 HOY PUEDES ACCEDER A TODO ESTE SISTEMA POR SOLO:
            </p>
            <p className="text-7xl md:text-8xl lg:text-9xl font-bold text-brand-green text-center mb-8" data-id="element-511">
              $14.99
            </p>

            <div className="space-y-3 max-w-lg mx-auto mb-8" data-id="element-512">
              <p className="flex items-start gap-3 text-brand-text/80 text-lg" data-id="element-513">
                <span className="mt-0.5" data-id="element-514">👉</span>
                <span className="font-semibold" data-id="element-515">
                  MENOS DE LO QUE GASTAS EN UNA SALIDA
                </span>
              </p>
              <p className="flex items-start gap-3 text-brand-text/80 text-lg" data-id="element-516">
                <span className="mt-0.5" data-id="element-517">👉</span>
                <span className="font-semibold" data-id="element-518">
                  PERO CON EL POTENCIAL REAL DE GENERAR INGRESOS DESDE CASA
                </span>
              </p>
            </div>

            {/* Urgency */}
            <div className="bg-red-50 border border-red-200 rounded-xl p-4 mb-8 text-center" data-id="element-519">
              <p className="text-red-700 font-bold text-base md:text-lg" data-id="element-520">
                ⚠️ ESTE PRECIO ES DE LANZAMIENTO Y PUEDE CAMBIAR EN CUALQUIER
                MOMENTO
              </p>
            </div>

            {/* CTA Button */}
            <div className="text-center mb-6" data-id="element-521">
              <Button onClick={() => window.open('https://43skvt-1y.myshopify.com/products/como-vender-en-amazon-fba-desde-cero-2026-bonos-exclusivos', '_blank')} className="w-full md:w-auto text-xl px-14 py-6 shadow-xl" data-id="element-522">
                👉 QUIERO EMPEZAR AHORA
              </Button>
            </div>

            {/* Trust badges */}
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-8 text-brand-text/60 text-sm" data-id="element-523">
              <span className="flex items-center gap-2" data-id="element-524">
                <Zap className="w-4 h-4 text-brand-green" data-id="element-525" />
                ACCESO INMEDIATO
              </span>
              <span className="flex items-center gap-2" data-id="element-526">
                <Download className="w-4 h-4 text-brand-green" data-id="element-527" />
                DESCARGA DIGITAL
              </span>
              <span className="flex items-center gap-2" data-id="element-528">
                <ShieldCheck className="w-4 h-4 text-brand-green" data-id="element-529" />
                COMPRA SEGURA
              </span>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}